module.exports = __webpack_public_path__ + "img/englishTeacher-xl.5887d38e.png";